(function () {
    const advancedFiltersToggle = document.getElementById('advancedFiltersToggle');
    const advancedFilters = document.getElementById('advancedFiltersContainer');

    if (!advancedFiltersToggle || !advancedFilters) {
        return;
    }

    const labelSpan = advancedFiltersToggle.querySelector('.buttonText');

    advancedFiltersToggle.addEventListener('click', function (event) {
        event.preventDefault();

        const isHidden =
            advancedFilters.hasAttribute('hidden') ||
            advancedFilters.getAttribute('aria-hidden') === 'true';

        if (isHidden) {
            // Show
            advancedFilters.removeAttribute('hidden');
            advancedFilters.setAttribute('aria-hidden', 'false');
            advancedFiltersToggle.setAttribute('aria-expanded', 'true');

            if (labelSpan) {
                labelSpan.textContent = 'Close';
            }

            const firstSelect = advancedFilters.querySelector('select');
            if (firstSelect) {
                firstSelect.focus();
            }
        } else {
            advancedFilters.setAttribute('hidden', '');
            advancedFilters.setAttribute('aria-hidden', 'true');
            advancedFiltersToggle.setAttribute('aria-expanded', 'false');

            if (labelSpan) {
                labelSpan.textContent = 'Advanced search';
            }
        }
    });
})();
